export interface UserState {
    username?: string;
    userId?: string;
    email?: string;
    nickname?: string;
    mobile?: string;
    mobileRegion?: string;
    hasPassword: boolean;
    hasWeixin: boolean;
    isAgree?: boolean;
}
export const useUserStore = defineStore(
    'user',
    () => {
        const userState = ref<UserState>({
            username: '',
            isAgree: false,
            userId: '',
            email: '',
            mobile: undefined,
            mobileRegion: undefined,
            nickname: undefined,
            hasWeixin: false,
            hasPassword: false,
        });
        const clearUser = () => {
            userState.value = {
                username: '',
                userId: '',
                email: '',
                mobile: undefined,
                mobileRegion: undefined,
                nickname: undefined,
                hasWeixin: false,
                hasPassword: false,
            };
        };
        const setUserInfo = (userInfo: any) => {
            userState.value = userInfo;
        };
        const setUserNickName = (nickname: string) => {
            userState.value.nickname = nickname;
        };
        const setUserAgree = (isAgree: boolean) => {
            userState.value.isAgree = isAgree;
        };
        const userName = computed(() => userState.value.username);
        const email = computed(() => userState.value.email);
        const userId = computed(() => userState.value.userId);
        const userNickName = computed(() => userState.value.nickname);
        const userAgree = computed(() => userState.value.isAgree);
        const mobile = computed(() => userState.value.mobile);
        return {
            clearUser,
            setUserInfo,
            userState: userState,
            email,
            mobile,
            userName,
            userId,
            userNickName,
            setUserNickName,
            userAgree,
            setUserAgree,
        };
    },
    {
        // 开启持久化（默认使用 localStorage）
        // persist: {
        //     storage: localStorage,
        //     key: 'user-store',
        //     paths: ['userId', 'userName'], // 只持久化 userState
        // },
    }
);

export default useUserStore;
